import { Injectable } from '@angular/core';

@Injectable()
export class StaticDataService {
  constructor() { }

  private requiredBy = [
    { id: "immediately", name: "Immediately" },
    { id: "one", name: "1-3 months" },
    { id: "three", name: "3-6 months" },
    { id: "six", name: "6 months+" }
  ];

  private quoteStatusCustomer = [
    // { id: "new", name: "New" },
    { id: "approved", name: "Approved" },
    { id: "cancelled", name: "Cancelled" },
  ];

  private quoteStatus = [
    { id: "new", name: "New" },
    { id: "approved", name: "Approved" },
    { id: "awaiting_payment", name: "Awaiting Payment" },
    { id: "payment_received", name: "Payment Received" },
    { id: "in_progress", name: "In Progress" },
    { id: "shipped", name: "Shipped" },
    { id: "delivered", name: "Delivered" },
    { id: "cancelled", name: "Cancelled" },
    { id: "refunded", name: "Refunded" },
  ]

  getRequiredBy() {
    return this.requiredBy;
  }

  getQuoteStatusCustomer() {
    return this.quoteStatusCustomer;
  }

  getQuoteStatus() {
    return this.quoteStatus;
  }

}
